import { render, staticRenderFns } from "./articleSingle.vue?vue&type=template&id=31d9a30b&scoped=true&"
import script from "./articleSingle.vue?vue&type=script&lang=js&"
export * from "./articleSingle.vue?vue&type=script&lang=js&"
import style0 from "./articleSingle.vue?vue&type=style&index=0&id=31d9a30b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9a30b",
  null
  
)

export default component.exports